'use strict';

exports.__esModule = true;
exports.registerField = registerField;
exports.setMultipleFields = setMultipleFields;
exports.setFormFieldProperty = setFormFieldProperty;
exports.clearForm = clearForm;
exports.clearFormProperty = clearFormProperty;
exports.setFieldValue = setFieldValue;
exports.setFieldLiveValidation = setFieldLiveValidation;
exports.setFieldError = setFieldError;
exports.setFieldApiError = setFieldApiError;
exports.default = createFormActions;
var SET_ONION_FORM_FIELD_PROPERTY = exports.SET_ONION_FORM_FIELD_PROPERTY = 'SET_ONION_FORM_FIELD_PROPERTY';
var SET_ONION_FORM_MULTIPLE_FIELDS = exports.SET_ONION_FORM_MULTIPLE_FIELDS = 'SET_ONION_FORM_MULTIPLE_FIELDS';
var REGISTER_ONION_FORM_FIELD = exports.REGISTER_ONION_FORM_FIELD = 'REGISTER_ONION_FORM_FIELD';
var CLEAR_ONION_FORM_PROPERTY = exports.CLEAR_ONION_FORM_PROPERTY = 'CLEAR_ONION_FORM_PROPERTY';
var CLEAR_ONION_FORM = exports.CLEAR_ONION_FORM = 'CLEAR_ONION_FORM';

function registerField(form, field) {
  return {
    type: REGISTER_ONION_FORM_FIELD,
    form: form,
    field: field
  };
}

function setMultipleFields(form, property, values) {
  return {
    type: SET_ONION_FORM_MULTIPLE_FIELDS,
    form: form,
    property: property,
    values: values
  };
}

function setFormFieldProperty(form, field, property, value) {
  return {
    type: SET_ONION_FORM_FIELD_PROPERTY,
    form: form,
    field: field,
    property: property,
    value: value
  };
}

function clearForm(form) {
  return {
    type: CLEAR_ONION_FORM,
    form: form
  };
}

function clearFormProperty(form, property) {
  return {
    type: CLEAR_ONION_FORM_PROPERTY,
    form: form,
    property: property
  };
}

function setFieldValue(form, field, value) {
  return setFormFieldProperty(form, field, 'value', value);
}

function setFieldLiveValidation(form, field) {
  return setFormFieldProperty(form, field, 'liveValidation', true);
}

function setFieldError(form, field, error) {
  return setFormFieldProperty(form, field, 'error', error);
}

function setFieldApiError(form, field, error) {
  return setFormFieldProperty(form, field, 'apiError', error);
}

function createFormActions(form) {
  return {
    clearForm: clearForm.bind(null, form),
    clearFormProperty: clearFormProperty.bind(null, form),
    registerField: registerField.bind(null, form),
    setFieldApiError: setFieldApiError.bind(null, form),
    setFieldLiveValidation: setFieldLiveValidation.bind(null, form),
    setFieldError: setFieldError.bind(null, form),
    setFieldValue: setFieldValue.bind(null, form),
    setFormFieldProperty: setFormFieldProperty.bind(null, form),
    setMultipleFields: setMultipleFields.bind(null, form)
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/onion-form/lib/actions.js
// module id = 163
// module chunks = 0